
export default {
  name: 'Results',
  props: {
    address: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    change() {
      this.$emit('change');
    },
    printResults() {
      window.print();
    },
  },
};
